import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Specialists from "../components/Specialists";
import Community from "../components/Community";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import CustomerStories from "../components/CustomerStories";
import EmpowermentVision from "../components/EmpowermentVision";
import BharatIconHero from "../components/BharatIconUsa";
// import TeleVid from "../components/TeleVid";
export default function Home() {
    return (
        <div className="font-sans text-gray-800">
            <Navbar />
            {/* HERO */}
            <Hero />

            {/* SERVICES */}
            <Services />

            {/* SPECIALISTS */}
            <Specialists />

            {/* COMMUNITY */}
            <Community />

            {/* EMPOWERMENT VISION */}
            <EmpowermentVision />

            {/* BHARAT ICON USA */}
            <BharatIconHero />

            {/* CONTACT */}
            <Contact />
            {/*TeleVid*/}
            {/* <TeleVid /> */}
            {/* CUSTOMER STORIES */}
            <CustomerStories />

            {/* FOOTER */}
            <Footer />
        </div>
    );
}